import type { FC } from 'react';
import { useCallback } from 'react';
import { useEntityStore } from '@ContractBuilder/store';
import { useMultiSelectStore } from '@ContractBuilder/store/multi-select.store';
import { canChange } from '@helpers/canChange';

import { BlockCheckbox, CheckboxSpacer } from '../views/BlockCheckbox';

interface BlockCheckboxControllerProps {
  partId: string;
  blockId: string;
  blockName?: string;
}

export const BlockCheckboxController: FC<BlockCheckboxControllerProps> = ({ partId, blockId, blockName }) => {
  const submissionStatus = useEntityStore((state) => state.submission?.status);
  const isChecked = useMultiSelectStore(
    (state) => state.activePartId === partId && state.selectedBlockIds.has(blockId),
  );
  const isVisible = useMultiSelectStore((state) => state.activePartId === partId && state.selectedBlockIds.size > 0);
  const isAnotherPartActive = useMultiSelectStore(
    (state) => state.activePartId !== null && state.activePartId !== partId && state.selectedBlockIds.size > 0,
  );
  const toggleBlockSelection = useMultiSelectStore((state) => state.toggleBlockSelection);

  const handleChange = useCallback(() => {
    toggleBlockSelection(partId, blockId);
  }, [blockId, partId, toggleBlockSelection]);

  // Mirror the single-block delete gate (BlockMenu disables itself via canChange). When the
  // submission/template/endorsement isn't in an editable state (e.g. FINAL, ARCHIVED), the
  // multi-select checkbox shouldn't render — there's no operation the user could perform.
  if (!canChange(submissionStatus) || isAnotherPartActive) {
    return <CheckboxSpacer />;
  }

  return (
    <BlockCheckbox
      checked={isChecked}
      isVisible={isVisible}
      blockId={blockId}
      blockName={blockName}
      onChange={handleChange}
    />
  );
};
